import React from 'react';
import ManualAlert from './ManualAlert';
import AIAlert from './AIAlert';
import { AlertPanelWrapper } from './styled';

function AlertPanel() {
  return (
    <AlertPanelWrapper>
      <ManualAlert />
      <AIAlert />
    </AlertPanelWrapper>
  )
}


export default AlertPanel;
